/**
 * Router Abstraction so it's easier to swap out routing implementations. This
 * will navigate to a new route. This makes it easier to change from Backbone Router
 * to React Router etc...
 */

import log from 'loglevel'
import { push, replace, goBack, goForward } from 'connected-react-router'
import reduxStore from '../stores/configureStore'
import { getUrlFragment } from './url-utils'

/**
 * Will navigate to a new route. This implementation uses the browserHistory module
 * that comes with react-router
 * @param targetRoute string - '/request'. New url to route to
 * @param options {obj} - Optional object with options
 * @param options.replace {bool} - If set, use react-router--redux replace()
 * @param options.refresh {bool} - say to use raw window.location methods (causes full page refresh)
 */
export function routeTo(targetRoute, options = {}) {
  log.info(`routeTo: '${targetRoute}'`, options)
  const fullPath = getFullURL(targetRoute)
  if (options.refresh) {
    if (options.replace) {
      window.location.replace(fullPath)
    } else {
      window.location.assign(fullPath)
    }
  } else if (options.replace) {
    reduxStore.dispatch(replace(fullPath))
  } else {
    reduxStore.dispatch(push(fullPath))
  }
}

/**
 * Get a full URL by checking the redux store for the
 * root and appending it if needed.
 */
export function getFullURL(path) {
  const state = reduxStore.getState()
  const { rootURL } = state.server
  if (path.includes(rootURL)) {
    path = getUrlFragment(path, rootURL)
  }
  const fullPath = rootURL + path
  return fullPath
}

export const back = () => {
  reduxStore.dispatch(goBack())
}

export const forward = () => {
  reduxStore.dispatch(goForward())
}
